var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "inputFullName", class: { isPc: !_vm.isSp } },
      [
        _c(
          "InputLabel",
          {
            staticClass: "labelArea",
            class: {
              isPc: !_vm.isSp,
              isHasLabel: !_vm.isSp && _vm.required,
              styleLabelWide: _vm.styleLabelWide,
              isPcModal: _vm.isPcModal,
            },
            attrs: { required: _vm.required },
          },
          [_vm._v("\n      " + _vm._s(_vm.areaLabel) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "inputsArea",
            class: { isFormCompanionPC: !_vm.isSp && _vm.isFormCompanion },
          },
          [
            _c("InputItem", {
              staticClass: "inputItem",
              class: {
                hasError: _vm.hasErrorSei,
                isPc: !_vm.isSp,
                smallInput: _vm.smallInput,
              },
              attrs: {
                id: _vm.idSei,
                "input-value": _vm.nameObject.sei,
                "input-type": "text",
                "placeholder-value": _vm.placeholder.sei,
                disabled: _vm.lastNameDisabled,
              },
              on: {
                blur: _vm.onBlurSei,
                change: _vm.onChangeSei,
                focus: _vm.onFocusSei,
              },
            }),
            _vm._v(" "),
            _c("InputItem", {
              staticClass: "inputItem",
              class: {
                hasError: _vm.hasErrorMei,
                isPc: !_vm.isSp,
                smallInput: _vm.smallInput,
              },
              attrs: {
                id: _vm.idMei,
                "input-value": _vm.nameObject.mei,
                "input-type": "text",
                "placeholder-value": _vm.placeholder.mei,
                disabled: _vm.firstNameDisabled,
              },
              on: {
                blur: _vm.onBlurMei,
                change: _vm.onChangeMei,
                focus: _vm.onFocusMei,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "underInputArea",
        class: {
          isPc: !_vm.isSp,
          isNoLabelInPc: !_vm.isSp && !_vm.required,
          styleLabelWide: _vm.styleLabelWide,
          isFormCompanion: _vm.isFormCompanion,
        },
      },
      [
        _c("PartialErrorMessage", {
          staticClass: "partialErrorComponent",
          attrs: { "is-sp-flg": true, error: _vm.displayErrorSei },
        }),
        _vm._v(" "),
        _c("PartialErrorMessage", {
          staticClass: "partialErrorComponent",
          class: { hasTwoError: _vm.hasErrorSei },
          attrs: { "is-sp-flg": true, error: _vm.displayErrorMei },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }